<template>
  <div class="lyanApp" v-loading.fullscreen.lock="fullscreenLoading" element-loading-text="数据加载中" element-loading-background="rgba(0, 0, 0, 0)" element-loading-spinner="el-icon-loading" :style="'min-height:'+curHeight+'px'">
    <div class="commen">
      <h2>
        <div class="ctitle">Message Board</div>
      </h2>
      <ul class="lyan">
        <div v-if="setLyanIndex.length <= 0" style="text-align:center;padding:60px 0">No messages yet~</div>
        <li v-for="(item,i) in setLyanIndex" v-if="setLyanIndex.length > 0">
          <div class="user">
            <span>{{item.username}}</span>
            <font>{{item.createtime}}</font>
          </div>
          <p>{{item.content}}</p>
        </li>
      </ul>
    </div>
    <div class="add" @click="$router.push('add')"><img src="~assets/images/add.png"/></div>
  </div>
</template>
<script>
  import $ from 'jquery'
  export default {
    data() {
      return {
        curHeight:0,
        fullscreenLoading: false,
        baseUrl:'',
        setLyanIndex:[]
      };
    },
    beforeMount() {
      this.baseUrl = this.$host;
    },
    mounted() {
      this.beforeMount();
      this.getLyanIndex()
    },
    methods: {
      beforeMount:function(){
        var h = document.documentElement.clientHeight || document.body.clientHeight;
        this.curHeight =h; //减去页面上固定高度height
      },
      getLyanIndex:function(){
        var that = this;
        that.fullscreenLoading = true;
        $.ajax({
          type:'post',
          url:that.$host+'home/index/lyan',
          dataType:'json',
          success:function(data){
            that.setLyanIndex = data.data;
            that.fullscreenLoading = false;
          }
        })
      },
    },
  };
</script>

<style>
  .el-loading-spinner{
    width:30%;
    background:rgba(0,0,0,0.8);
    left:50%;
    transform: translateX(-50%);
    border-radius:5px;
    padding:15px 0;
    color:#fff;
  }
  .el-loading-spinner i{
    color:#fff;
    font-size:22px
  }
  .el-loading-spinner .el-loading-text{
    color:#fff;
  }
  .lyanApp .el-message-box{
    width:30%
  }
  .lyanApp{
    max-width:750px;
    margin:0 auto;
    background:#fff
  }
  .lyanApp .commen ul li:after{
    clear: both;
    content: '.';
    display: block;
    width: 0;
    height: 0;
    visibility: hidden;
  }
  
  .lyanApp .commen{
    background:#fff;
    width:100%;
  }
  .lyanApp .commen h2{
    margin:0 auto;
    font-size:16px;
    padding:15px 0;
    border-bottom:solid 1px #f5f5f5;
  }
  .lyanApp .commen h2 .ctitle{
    width:92%;
    margin:0 auto;
    position:relative;
  }
  .lyanApp .commen h2 a{
    float:right;
    font-size:14px;
    font-weight:normal;
    color:#666;
    margin-top:2px
  }
  
  .lyanApp .commen .lyan{
    width: 92%;
    margin: 0 auto;
  }
  .lyanApp .commen .lyan li{
    width:100%;
    margin:15px auto 0 auto;
    border-bottom:solid 1px #f5f5f5;
    padding-bottom:15px
  }
  .lyanApp .commen .lyan li .user span{
    font-weight:bold;
    font-size:16px;
    color:#000
  }
  .lyanApp .commen .lyan li .user font{
    float:right;
    font-size:14px;
    color:#666
  }
  .lyanApp .commen .lyan li p{
    font-size:15px;
    color:#333;
    padding-top:8px;
    line-height:22px
  }

  .lyanApp .add{
    position: fixed;
    bottom:50px;
    right:4%
  }
  .lyanApp .add img{
    display:block;
    width:60px
  }
</style>